import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import {Row, Col, Container} from 'reactstrap';
import InfiniteScroll from "react-infinite-scroll-component";
import LoadingImage from "../../comum/components/LoadingImage";
import OSWebCard from "../components/OSWebCard"
import { HeaderTableFixed } from "../../../utils/headerTableFixed";

@inject("store")
@observer
export class TabelaOsweb extends Component{

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;

        this.controller = this.props.controller;
        
        window.addEventListener('scroll', HeaderTableFixed);
    };

    render() {
        return (
            <Container fluid className="tabela-container">
                { this.controller.loading ? <LoadingImage/>

                : <React.Fragment>
                    { !(this.controller.oswebLista.length > 0)
                        ? <Row>
                            <Col xs={12}>
                                <span className="mensagem-filtrar">
                                    {this.controller.tableMessage}
                                </span>
                            </Col>
                        </Row>
                        :

                        <InfiniteScroll
                            dataLength = {this.controller.items.length}
                            next = {() => this.controller.loadNextTurn()}
                            hasMore = {this.controller.hasMore}
                            loader = {<LoadingImage/>}
                        >
                            <ToolkitProvider
                            keyField="Id"
                            data={[...this.controller.items]}
                            columns={[...this.controller.colunas]} >
                            {props => (
                                <div>
                                    { window.innerWidth > 991
                                        ? 
                                        <div id="tableHeaderFixed" className="tabela-overflow">
                                            <BootstrapTable bootstrap4
                                                        striped
                                                        bordered={false}
                                                        noDataIndication={() => this.controller.noData}
                                                        classes="tabela tabela-layout osweb"
                                                        {...props.baseProps} />
                                        </div>
                                        : <Row>
                                            {this.controller.items.map((card, x) => (
                                                <OSWebCard
                                                    key={x}
                                                    data={card}
                                                    id={x}
                                                    colunas={[...this.controller.colunas]}
                                                />
                                            )) }
                                        </Row>
                                    }
                                </div>)
                            }
                        </ToolkitProvider>
                    </InfiniteScroll> }
                </React.Fragment> }

            </Container>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/osweb/components/TabelaOsweb.js